module.exports = __webpack_public_path__ + "img/angry.226666dc.svg";